import { render, staticRenderFns } from "./FilterBrands.vue?vue&type=template&id=028ddf31&scoped=true&"
import script from "./FilterBrands.vue?vue&type=script&lang=js&"
export * from "./FilterBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ddf31",
  null
  
)

export default component.exports